export const addAccessoryToCart = (state) => ({
  ...state,
  activeItem: {
    ...state.activeItem,
    isAdding: true,
    isAdded: false,
  },
});

export const addedAccessoryToCart = (state, action) => ({
  ...state,
  activeItem: {
    ...state.activeItem,
    isAdding: false,
    isAdded: action.isAdded,
  },
});
